module.exports = __webpack_public_path__ + "img/logo-whappy.298fe1fa.png";